import { NavLink } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthProvider';
import styles from './Sidebar.module.scss';

interface SidebarProps {
    isMobileOpen: boolean;
    onMobileClose: () => void;
}

const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: 'grid_view' },
    { path: '/cashflows', label: 'Income & Expenses', icon: 'cashflow' },
    { path: '/goals', label: 'Goals', icon: 'target' },
    { path: '/residency', label: 'Residency', icon: 'globe' },
    { path: '/simulator', label: 'Simulator', icon: 'chart' },
    { path: '/tax', label: 'Tax Deep-Dive', icon: 'tax' },
    { path: '/pensions', label: 'Pensions', icon: 'pension' },
    { path: '/healthcare-bridge', label: 'Healthcare Bridge', icon: 'health' },
];

export function Sidebar({ isMobileOpen, onMobileClose }: SidebarProps) {
    const { signOut } = useAuth();
    return (
        <aside className={`${styles.sidebar} ${isMobileOpen ? styles.mobileOpen : ''}`}>
            <div className={styles.brand}>
                <div className={styles.logo}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <circle cx="14" cy="14" r="12" stroke="currentColor" strokeWidth="2" />
                        <path d="M8 14h12M14 8v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>
                <div className={styles.brandText}>
                    <span className={styles.brandName}>Expat Horizon</span>
                    <span className={styles.brandSub}>Cross-Border Finance</span>
                </div>
            </div>

            <nav className={styles.nav}>
                <ul className={styles.navList}>
                    {navItems.map((item) => (
                        <li key={item.path}>
                            <NavLink
                                to={item.path}
                                className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
                                onClick={onMobileClose}
                            >
                                <span className={styles.navIcon}>
                                    {item.icon === 'grid_view'
                                        ? '◫'
                                        : item.icon === 'cashflow'
                                          ? '↕'
                                          : item.icon === 'target'
                                            ? '◎'
                                            : item.icon === 'globe'
                                              ? '🌐'
                                              : item.icon === 'chart'
                                                ? '📈'
                                                : item.icon === 'tax'
                                                  ? '🧾'
                                                  : item.icon === 'pension'
                                                    ? '🏛️'
                                                    : item.icon === 'health'
                                                      ? '🏥'
                                                      : '◫'}
                                </span>
                                <span className={styles.navLabel}>{item.label}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>

            <div className={styles.bottomSection}>
                <ul className={styles.navList}>
                    <li>
                        <button className={styles.navItem} onClick={signOut}>
                            <span className={styles.navIcon}>⏻</span>
                            <span className={styles.navLabel}>Sign Out</span>
                        </button>
                    </li>
                </ul>
            </div>
        </aside>
    );
}
